<template>
  <el-table-column
    prop="id"
    sortable="custom"
    label="Bizonylatszám"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      <receipt-link
        v-if="scope.row.status !== 'cancelled' && scope.row.receipt_number"
        :id="scope.row.id"
        :label="scope.row.receipt_number"
        type="customerSale"
      />
    </template>
  </el-table-column>
</template>

<script>
import ReceiptLink from '../../../utils/ReceiptLink';

export default {
  components: {
    ReceiptLink,
  },
  propName: 'receipt_number',
};
</script>

